module.exports = __webpack_public_path__ + "img/twitter-icon.7e1b70b9.svg";